import Splide from '@splidejs/splide';

const gk_sld = {
  load() {
    const blocks = document.querySelectorAll('.SliderBlock.splide');
    if (!blocks.length) return;

    blocks.forEach((el) => {
      if (el._splide) return;

      const slideCount = el.querySelectorAll('.splide__slide').length;
      if (slideCount < 2) return;

      const reveal   = el.dataset.reveal || 'fade';
      const speed    = parseInt(el.dataset.speed, 10) || 750;
      const autoplay = el.dataset.autoplay === '1';
      const interval = parseInt(el.dataset.autoplayInterval, 10) || 5000;
      const rewind   = el.dataset.rewind === '' || el.dataset.rewind === undefined
                         ? true
                         : el.dataset.rewind === '1';
      const showArrows = el.dataset.arrowsPosition !== 'hidden';
      const showDots   = el.dataset.dotsPosition !== 'hidden';

      const perPageXl  = parseInt(el.dataset.perPageXl,  10) || 1;
      const perPageLg  = parseInt(el.dataset.perPageLg,  10) || 1;
      const perPageMd  = parseInt(el.dataset.perPageMd,  10) || 1;
      const perPageSm  = parseInt(el.dataset.perPageSm,  10) || 1;
      const perPageXsl = parseInt(el.dataset.perPageXsl, 10) || 1;
      const perPageXs  = parseInt(el.dataset.perPageXs,  10) || 1;
      const safeXl     = Math.min(perPageXl, slideCount);

      const allOne = safeXl === 1 && perPageLg === 1 && perPageMd === 1 &&
                     perPageSm === 1 && perPageXsl === 1 && perPageXs === 1;

      const splide = new Splide(el, {
        type:    (allOne && (reveal === 'fade' || reveal === 'clip-reveal')) ? 'fade' : 'slide',
        perPage: safeXl,
        speed,
        rewind,
        autoplay,
        interval,
        breakpoints: {
          1199: { perPage: Math.min(perPageLg,  slideCount) },
          1023: { perPage: Math.min(perPageMd,  slideCount) },
           990: { perPage: Math.min(perPageSm,  slideCount) },
           767: { perPage: Math.min(perPageXsl, slideCount) },
           399: { perPage: Math.min(perPageXs,  slideCount) },
        },
        arrows:     showArrows,
        pagination: showDots,
        gap:        'var(--slider-gap, 20px)',
        easing:     'cubic-bezier(0.76, 0, 0.24, 1)',
        keyboard:   'global',
        lazyLoad:   'nearby',
        i18n: {
          prev:   'Diapositive précédente',
          next:   'Diapositive suivante',
          first:  'Première diapositive',
          last:   'Dernière diapositive',
          slideX: 'Diapositive %s',
          pageX:  'Page %s',
        },
      });

      // ── Effet reveal zoom + clip-reveal (D22) ────────────────────────────
      // FADE : géré nativement par Splide (type:'fade'), pas de .is-revealing
      if (reveal === 'zoom' || reveal === 'clip-reveal') {
        splide.on('move', (newIdx) => {
          const slidesEls = el.querySelectorAll('.splide__slide');
          const next = slidesEls[newIdx];
          if (!next) return;
          next.classList.add('is-revealing');
          setTimeout(() => next.classList.remove('is-revealing'), 800);
        });
      }

      splide.mount();
      el._splide = splide;
    });
  },
};

export default gk_sld;
